export const GET_SIGNATURE_DATA_ABORTED = 'GET_SIGNATURE_DATA_ABORTED';
export const GET_SIGNATURE_DATA_REQUESTED = 'GET_SIGNATURE_DATA_REQUESTED';
export const GET_SIGNATURE_DATA_COMPLETED = 'GET_SIGNATURE_DATA_COMPLETED';
export const GET_SIGNATURE_DATA_FAILED = 'GET_SIGNATURE_DATA_FAILED';
export const SET_SIGNATURE_DATA_REQUESTED = 'SET_SIGNATURE_DATA_REQUESTED';
export const SET_SIGNATURE_DATA_COMPLETED = 'SET_SIGNATURE_DATA_COMPLETED';
export const SET_SIGNATURE_DATA_FAILED = 'SET_SIGNATURE_DATA_FAILED';
export const RESET_SIGNATURE_DATA_REQUESTED = 'RESET_SIGNATURE_DATA_REQUESTED';
export const RESET_SIGNATURE_DATA_COMPLETED = 'RESET_SIGNATURE_DATA_COMPLETED';
